var ne = {};
module['exports'] = ne;
ne.title = "Nepalese";
ne.name = require("./name");
ne.address = require("./address");
ne.internet = require("./internet");
ne.company = require("./company");
ne.phone_number = require("./phone_number");